// extracted by mini-css-extract-plugin
module.exports = {"buttonWithSpinner":"VmSettings_buttonWithSpinner__3kvw3","userList":"VmSettings_userList__2iATD"};